module.exports = __webpack_public_path__ + "static/media/shape-footer.ebb79ad7.png";